import React from 'react';
import loadable from '@loadable/component';
import Loader from './Loader';
import { SM } from 'containers/App/constants';

const Async = loadable(
  props => {
    if (props.role && props.role.id === SM) {
      return import(`reports/${props.page}`);
    } else {
      return import(`containers/${props.page}`);
    }
  },
  {
    fallback: <Loader />,
    cacheKey: props => props.page, // fixed clear cache issue when user switch between pages, but it will cause the component not re-render when user switch between different pages with same name in different folder, e.g. reports/Appointment and containers/Appointment, but currently we don't have this case, so it should be fine for now
  },
);

export default Async;
